import { render, staticRenderFns } from "./PermissionsHelper.vue?vue&type=template&id=72d39954"
import script from "./PermissionsHelper.vue?vue&type=script&lang=js"
export * from "./PermissionsHelper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports